import $ from 'jquery';

/**
 * @param $el
 * @param options
 */
var ForceRepaint = {
    initialised: false
};

/**
 * Add
 */
ForceRepaint.init = function()
{
    if (this.initialised) {
        return;
    }

    $(window).on('resize load', function(e) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(this.update.bind(this), 50);
    }.bind(this));

    this.update();

    this.initialised = true;
}

/**
 * Update all elements
 */
ForceRepaint.update = function()
{
    var bs = document.body.style;
    bs.position = 'relative';
    setTimeout(function() {
        bs.position = 'static';
    }, 1);

    $('[data-force-repaint="true"]').each(function(i, el) {

        this.forceRedrawUsingTextNode(el);


        /*
        var style = el.style;
        var initial = style.position;
        style.position = (initial === 'relative') ? 'absolute' : 'relative';
        setTimeout(function() {
            style.position = initial;
        }, 10);
        */

    }.bind(this));
}

ForceRepaint.forceRedrawUsingTextNode = function(el) {
    var t = el.ownerDocument.createTextNode(' ');
    el.appendChild(t);
    setTimeout(function() { el.removeChild(t); }, 0);
}

ForceRepaint.defaults = {};

export default ForceRepaint;